module.exports = __webpack_public_path__ + "static/media/navbarlogo.c840ecd7.png";